import React from 'react'
import PropTypes from 'prop-types'

const BASE_CLASSES = 'tw:inline-block tw:whitespace-nowrap tw:rounded! '
  + 'tw:px-1.5 tw:py-0.5 tw:text-xs tw:font-medium'

const VARIANTS = {
  success: 'tw:bg-ds-primary-lowest-enabled tw:text-ds-primary-highest',
  progress: 'tw:bg-ds-progress-lowest tw:text-ds-progress-pressed',
  danger: 'tw:bg-ds-danger-lowest tw:text-ds-danger',
  neutral: 'tw:bg-gray-100 tw:text-gray-700'
}

const Badge = ({ children, variant }) =>
  <span className={`${BASE_CLASSES} ${VARIANTS[variant]}`}>{children}</span>

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['success', 'progress', 'danger', 'neutral'])
}

Badge.defaultProps = {
  variant: 'success'
}

export default Badge
